// Vendor Libraries
import { createAction, props } from '@ngrx/store';
// actions involving updating user preference in edit columns modal
export const setPreferenceIndicesCalcs = createAction('[Indices Edit Columns Modal] Set Preference Indices Calcs', props());
